<template>
  <div class="bg-white borderd">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <div class="block px-10 py-2 mx-auto mt-0 mb-20">
        <div class="flex">
          <div class="w-1/3 space-y-4">
            <div>
              <ValidationProvider v-slot="{ errors }" name="Namn" rules="required">
                <span class="text-gray-700">Namn</span>
                <input v-model="current.clientName" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Beskrivning" rules="required">
                <span class="text-gray-700">Beskrivning</span>
                <textarea rows="4" v-model="current.description" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Klient Url" rules="max:4">
                <span class="text-gray-700">Klient Url</span>
                <input v-model="current.clientUri" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Logo Url" rules="max:4">
                <span class="text-gray-700">Logo Url</span>
                <input v-model="current.logoUri" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
             </div>

            <div>
              <ValidationProvider name="Aktiv">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.enabled" />
                  <span class="form-label ml-2">Aktiv</span>
                </label>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Kräv samtycke">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.requireConsent" />
                  <span class="form-label ml-2">Kräv samtycke</span>
                </label>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Spara samtycke">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.allowRememberConsent" />
                  <span class="form-label ml-2">Spara samtycke</span>
                </label>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Aktivera Lokalt login">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.enableLocalLogin" />
                  <span class="form-label ml-2">Aktivera Lokalt login</span>
                </label>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Inkludera UserClaims i Token">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.alwaysIncludeUserClaimsInIdToken" />
                  <span class="form-label ml-2">Inkludera UserClaims i Token</span>
                </label>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Kräv klient secret">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.requireClientSecret" />
                  <span class="form-label ml-2">Kräv klient secret</span>
                </label>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="flex px-2 py-2 mt-12">
          <button class="block btn_default sm:w-auto sm:inline-block" @click="onDelete">
            Radera
          </button>

          <button class="block w-full btn_blue sm:w-auto sm:inline-block" :class="{ 'opacity-50': isDirty !== true || invalid }" :disabled="isDirty !== true || invalid" @click="onSave">
            Spara
          </button>
          <CloneClientDlg />
        </div>
      </div>
    </ValidationObserver>
    <DialogBase />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DialogBase from "@/components/dialogs/DialogBase.vue";
import { destroyDialog } from "@/components/dialogs/dialogs";
import CloneClientDlg from "./CloneClientDlg";

export default {
  name: "clientgeneral",
  components: { DialogBase, CloneClientDlg },
  computed: {
    ...mapGetters("clientsStore", ["current", "isDirty"])
  },

  methods: {
    ...mapActions("clientsStore", ["fetch", "save", "delete"]),
    async onSave() {
      await this.save();
      this.$refs.form.reset();
    },
    async onDelete() {
      const callback = async () => {
        try {
          await this.delete();
        } finally {
          this.$router.push("/clients");
          this.$modal.hide("dialog-base");
        }
      };
      destroyDialog(this, callback, "Klient " + this.current.clientId);
    }
  }
};
</script>
